import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-277bbbdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vh-100 d-flex" }
const _hoisted_2 = { class: "col-2 border-right" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mt-3" }, "Settings", -1))
const _hoisted_4 = { class: "row nav mt-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Folders", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Rules", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Users", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Bulk Rules", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Blocked Senders", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Domains", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Auto-Replies", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Email Templates", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Companies", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Message Error Log", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Good Domains", -1))
const _hoisted_16 = { class: "vh-100 col-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainNavigation = _resolveComponent("MainNavigation")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Folders = _resolveComponent("Folders")!
  const _component_Rules = _resolveComponent("Rules")!
  const _component_Users = _resolveComponent("Users")!
  const _component_BulkRules = _resolveComponent("BulkRules")!
  const _component_BlockedSenders = _resolveComponent("BlockedSenders")!
  const _component_Domains = _resolveComponent("Domains")!
  const _component_AutoReply = _resolveComponent("AutoReply")!
  const _component_EmailTemplates = _resolveComponent("EmailTemplates")!
  const _component_Companies = _resolveComponent("Companies")!
  const _component_ErrorLog = _resolveComponent("ErrorLog")!
  const _component_DomainGreenlist = _resolveComponent("DomainGreenlist")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MainNavigation, { folderId: null }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", {
          class: _normalizeClass(["col-12 nav-item pl-3 py-2", {
            'font-weight-bold': this.$route.path.startsWith('/settings/folders')
          }]),
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (
            _ctx.$router.push({
              name: 'settings',
              params: { area: 'folders' }
            })
          ), ["prevent"]))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['far', 'folder'],
            class: _normalizeClass({
              'text-primary': this.$route.path.startsWith('/settings/folders')
            })
          }, null, 8, ["class"]),
          _hoisted_5
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["col-12 nav-item pl-3 py-2", {
            'font-weight-bold ': this.$route.path.startsWith('/settings/rules')
          }]),
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (
            _ctx.$router.push({ name: 'settings', params: { area: 'rules' } })
          ), ["prevent"]))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['far', 'folder'],
            class: _normalizeClass({
              'text-primary': this.$route.path.startsWith('/settings/rules')
            })
          }, null, 8, ["class"]),
          _hoisted_6
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["col-12 nav-item pl-3 py-2", {
            'font-weight-bold ': this.$route.path.startsWith('/settings/users')
          }]),
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (
            _ctx.$router.push({ name: 'settings', params: { area: 'users' } })
          ), ["prevent"]))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['far', 'folder'],
            class: _normalizeClass({
              'text-primary': this.$route.path.startsWith('/settings/users')
            })
          }, null, 8, ["class"]),
          _hoisted_7
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["col-12 nav-item pl-3 py-2", {
            'font-weight-bold ': this.$route.path.startsWith(
              '/settings/bulkRules'
            )
          }]),
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (
            _ctx.$router.push({ name: 'settings', params: { area: 'bulkRules' } })
          ), ["prevent"]))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['far', 'folder'],
            class: _normalizeClass({
              'text-primary': this.$route.path.startsWith('/settings/bulkRules')
            })
          }, null, 8, ["class"]),
          _hoisted_8
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["col-12 nav-item pl-3 py-2", {
            'font-weight-bold ': this.$route.path.startsWith(
              '/settings/blockedSenders'
            )
          }]),
          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (
            _ctx.$router.push({
              name: 'settings',
              params: { area: 'blockedSenders' }
            })
          ), ["prevent"]))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['far', 'folder'],
            class: _normalizeClass({
              'text-primary': this.$route.path.startsWith(
                '/settings/blockedSenders'
              )
            })
          }, null, 8, ["class"]),
          _hoisted_9
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["col-12 nav-item pl-3 py-2", {
            'font-weight-bold ': this.$route.path.startsWith(
              '/settings/domains'
            )
          }]),
          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (
            _ctx.$router.push({ name: 'settings', params: { area: 'domains' } })
          ), ["prevent"]))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['far', 'folder'],
            class: _normalizeClass({
              'text-primary': this.$route.path.startsWith('/settings/domains')
            })
          }, null, 8, ["class"]),
          _hoisted_10
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["col-12 nav-item pl-3 py-2", {
            'font-weight-bold ': this.$route.path.startsWith(
              '/settings/autoReply'
            )
          }]),
          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (
            _ctx.$router.push({ name: 'settings', params: { area: 'autoReply' } })
          ), ["prevent"]))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['far', 'folder'],
            class: _normalizeClass({
              'text-primary': this.$route.path.startsWith('/settings/autoReply')
            })
          }, null, 8, ["class"]),
          _hoisted_11
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["col-12 nav-item pl-3 py-2", {
            'font-weight-bold ': this.$route.path.startsWith(
              '/settings/emailTemplates'
            )
          }]),
          onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (
            _ctx.$router.push({
              name: 'settings',
              params: { area: 'emailTemplates' }
            })
          ), ["prevent"]))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['far', 'folder'],
            class: _normalizeClass({
              'text-primary': this.$route.path.startsWith(
                '/settings/emailTemplates'
              )
            })
          }, null, 8, ["class"]),
          _hoisted_12
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["col-12 nav-item pl-3 py-2", {
            'font-weight-bold ': this.$route.path.startsWith(
              '/settings/companies'
            )
          }]),
          onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (
            _ctx.$router.push({ name: 'settings', params: { area: 'companies' } })
          ), ["prevent"]))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['far', 'folder'],
            class: _normalizeClass({
              'text-primary': this.$route.path.startsWith('/settings/companies')
            })
          }, null, 8, ["class"]),
          _hoisted_13
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["col-12 nav-item pl-3 py-2", {
            'font-weight-bold ': this.$route.path.startsWith(
              '/settings/errorLog'
            )
          }]),
          onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (
            _ctx.$router.push({ name: 'settings', params: { area: 'errorLog' } })
          ), ["prevent"]))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['far', 'folder'],
            class: _normalizeClass({
              'text-primary': this.$route.path.startsWith('/settings/errorLog')
            })
          }, null, 8, ["class"]),
          _hoisted_14
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["col-12 nav-item pl-3 py-2", {
            'font-weight-bold ': this.$route.path.startsWith(
              '/settings/goodDomains'
            )
          }]),
          onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (
            _ctx.$router.push({ name: 'settings', params: { area: 'goodDomains' } })
          ), ["prevent"]))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['far', 'folder'],
            class: _normalizeClass({
              'text-primary': this.$route.path.startsWith('/settings/goodDomains')
            })
          }, null, 8, ["class"]),
          _hoisted_15
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      (this.$route.path.startsWith('/settings/folders'))
        ? (_openBlock(), _createBlock(_component_Folders, { key: 0 }))
        : _createCommentVNode("", true),
      (this.$route.path.startsWith('/settings/rules'))
        ? (_openBlock(), _createBlock(_component_Rules, { key: 1 }))
        : _createCommentVNode("", true),
      (this.$route.path.startsWith('/settings/users'))
        ? (_openBlock(), _createBlock(_component_Users, { key: 2 }))
        : _createCommentVNode("", true),
      (this.$route.path.startsWith('/settings/bulkRules'))
        ? (_openBlock(), _createBlock(_component_BulkRules, { key: 3 }))
        : _createCommentVNode("", true),
      (this.$route.path.startsWith('/settings/blockedSenders'))
        ? (_openBlock(), _createBlock(_component_BlockedSenders, { key: 4 }))
        : _createCommentVNode("", true),
      (this.$route.path.startsWith('/settings/domains'))
        ? (_openBlock(), _createBlock(_component_Domains, { key: 5 }))
        : _createCommentVNode("", true),
      (this.$route.path.startsWith('/settings/autoReply'))
        ? (_openBlock(), _createBlock(_component_AutoReply, { key: 6 }))
        : _createCommentVNode("", true),
      (this.$route.path.startsWith('/settings/emailTemplates'))
        ? (_openBlock(), _createBlock(_component_EmailTemplates, { key: 7 }))
        : _createCommentVNode("", true),
      (this.$route.path.startsWith('/settings/companies'))
        ? (_openBlock(), _createBlock(_component_Companies, { key: 8 }))
        : _createCommentVNode("", true),
      (this.$route.path.startsWith('/settings/errorLog'))
        ? (_openBlock(), _createBlock(_component_ErrorLog, { key: 9 }))
        : _createCommentVNode("", true),
      (this.$route.path.startsWith('/settings/goodDomains'))
        ? (_openBlock(), _createBlock(_component_DomainGreenlist, { key: 10 }))
        : _createCommentVNode("", true)
    ])
  ]))
}